import { List } from '@mui/material';
import { BrowserRoutes } from 'core/enums';
import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import { drawerRoutes } from './DrawerRoutes';
import ExpandableRoute from './ExpandableRoute';
import { StyledListItem } from './Styles';

const DrawerList: FC<{ isMinimized: boolean }> = ({ isMinimized }) => {
  const { userStore } = useStores();
  const navigate = useNavigate();
  const location = useLocation();
  const [pathName, setPathName] = useState(
    location.pathname.replace(/\/+$/g, ''),
  );

  const handleNavigationTabClick = useCallback(
    (route: BrowserRoutes) => {
      return () => {
        if (route === BrowserRoutes.LIVE_MONITORING) {
          userStore.generateCoralogixError('Press Live Monitoring');
        }

        navigate(route);
      };
    },
    [navigate],
  );

  useEffect(() => {
    setPathName(location.pathname.replace(/\/+$/g, ''));
  }, [location, setPathName]);

  return (
    <List component="nav" aria-labelledby="nested-list-subheader">
      <StyledListItem divider />
      {drawerRoutes.map((route) => (
        <ExpandableRoute
          key={route.title}
          title={route.title}
          icon={route.icon}
          defaultCollapsed={route.defaultCollapsed}
          childrenRoutes={route.childrenRoutes}
          isMinimized={isMinimized}
          pathName={pathName}
          onRouteClick={handleNavigationTabClick}
        />
      ))}
    </List>
  );
};

export default observer(DrawerList);
